import React from 'react';

const TopHeader = (props) => {
    return ( <>
    
    
    <div className="TopHeader">
            <div className="container">
                <div className="flex-row d-flex p-3 pr_toolbar">
                <img src={props.icon} alt="" onClick={props.backaction} className=""/> 
                <img src={props.app_logo} alt="" width="30px" height="30px" className="me-3 my-auto"/> 
                <b className="my-auto text-decoration-none text-dark">{props.pageTitle}</b>
                </div>
            </div>
            {/* <ServiceCat /> */}
    
            
        </div>
    
    </> );
}
 
export default TopHeader;